import { Box, Tooltip } from '@chakra-ui/react';
import { IoSync, IoSyncOutline } from 'react-icons/io5';

import { SETUP_GREEN } from '../home/setupProgress/constants';

/**
 * (3158) Whether the app auth syncs users: a green sync icon when it does, a
 * grey outline struck through when it doesn't.
 *
 * @param {object} props
 * @param {boolean} props.isActive
 */
const SyncIndicator = ({ isActive }) => {
    const label = isActive ? 'Sync enabled' : 'Sync disabled';

    return (
        <Tooltip label={label} hasArrow placement="bottom">
            <Box
                as="span"
                role="img"
                aria-label={label}
                position="relative"
                display="inline-flex"
                flexShrink={0}
                color={isActive ? SETUP_GREEN : 'gray.400'}>
                {isActive ? (
                    <IoSync size={14} aria-hidden />
                ) : (
                    <>
                        <IoSyncOutline size={14} aria-hidden />
                        <Box
                            position="absolute"
                            top="50%"
                            left="50%"
                            width="16px"
                            height="1.5px"
                            bg="currentColor"
                            transform="translate(-50%, -50%) rotate(-45deg)"
                        />
                    </>
                )}
            </Box>
        </Tooltip>
    );
};

export default SyncIndicator;
